import { render, staticRenderFns } from "./Extend.vue?vue&type=template&id=4f78db98&scoped=true"
import script from "./Extend.vue?vue&type=script&lang=js"
export * from "./Extend.vue?vue&type=script&lang=js"
import style0 from "./Extend.vue?vue&type=style&index=0&id=4f78db98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f78db98",
  null
  
)

export default component.exports